// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1r5tz","location":"Header_location__267x5"};